import { CompressionSimpleTextValueVO, ConnectionAreaUsageVO, MetaElementUsageIdentityVO, MetaElementUsageVO, MetaElementVO, TextureAreaUsageVO, TextureAreaVO } from '@shared/vo/meta-element.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleUtils } from '@article/util/article-utils';
import { ConnectionAreaUsageUtils } from '@shared/util/connection-area-usage-utils';

export class MetaElementUsageUtils {
  public static getCorridorInformationOfTextureArea(metaElementUsage: MetaElementUsageVO, article: ArticleVO): number {
    if (metaElementUsage == null || article == null || article.metaElements == null) {
      return NaN;
    }
    const metaElementUsageIdentity: MetaElementUsageIdentityVO = metaElementUsage.identity;
    if (metaElementUsageIdentity == null) {
      return NaN;
    }
    const metaElement: MetaElementVO = ArticleUtils.findMetaElementByName(article, metaElementUsageIdentity.metaElementName);
    if (metaElement == null || !(metaElement instanceof TextureAreaVO)) {
      return NaN;
    }
    return metaElement.corridor;
  }

  public static isMetaElementUsageIdentityEquals(identity1: MetaElementUsageIdentityVO, identity2: MetaElementUsageIdentityVO): boolean {
    if (!identity1 && !identity2) {
      return true;
    }
    if (!identity1 && identity2) {
      return false;
    }
    return identity1.equals(identity2);
  }

  public static backwardConnectedArticleUsageIds(metaElementUsage: MetaElementUsageVO): string[] {
    if(metaElementUsage instanceof ConnectionAreaUsageVO) {
      return ConnectionAreaUsageUtils.backwardConnectedArticleUsageIds(metaElementUsage);
    }
    return [];
  }

  public static backwardConnectedMetaElementUsageIdentities(metaElementUsage: MetaElementUsageVO): MetaElementUsageIdentityVO[] {
    if(metaElementUsage instanceof ConnectionAreaUsageVO) {
      return ConnectionAreaUsageUtils.backwardConnectedMetaElementUsageIdentities(metaElementUsage);
    }
    return [];
  }

  public static forwardConnectedArticleUsageIds(metaElementUsage: MetaElementUsageVO): string[] {
    if(metaElementUsage instanceof ConnectionAreaUsageVO) {
      return ConnectionAreaUsageUtils.forwardConnectedArticleUsageIds(metaElementUsage);
    }
    return [];
  }

  public static forwardConnectedMetaElementUsageIdentities(metaElementUsage: MetaElementUsageVO): MetaElementUsageIdentityVO[] {
    if(metaElementUsage instanceof ConnectionAreaUsageVO) {
      return ConnectionAreaUsageUtils.forwardConnectedMetaElementUsageIdentities(metaElementUsage);
    }
    return [];
  }

  public static isFreeConnectionUsage(metaElementUsage: MetaElementUsageVO, multiplicity: number = 0): boolean {
    if (!(metaElementUsage instanceof ConnectionAreaUsageVO)) {
      return true;
    }
    return ConnectionAreaUsageUtils.isFreeConnectionUsage(metaElementUsage, multiplicity);
  }

  public static textureAreaUsages(metaElementUsages: MetaElementUsageVO[]): TextureAreaUsageVO[] {
    const textureAreaUsages: TextureAreaUsageVO[] = [];
    for (const metaElementUsage of metaElementUsages) {
      if (metaElementUsage instanceof TextureAreaUsageVO) {
        textureAreaUsages.push(metaElementUsage);
      }
    }
    return textureAreaUsages;
  }

  static nonTextureAreaUsages(metaElementUsages: MetaElementUsageVO[]) {
    const nonTextureAreaUsages: MetaElementUsageVO[] = [];
    for (const metaElementUsage of metaElementUsages) {
      if (!(metaElementUsage instanceof TextureAreaUsageVO)) {
        nonTextureAreaUsages.push(metaElementUsage);
      }
    }
    return nonTextureAreaUsages;
  }

  public static isManualCompressionTextureUsage(
    metaElementUsage: MetaElementUsageVO,
  ): metaElementUsage is TextureAreaUsageVO & { textValue: CompressionSimpleTextValueVO & { autoCompression: false; autoFontSize: false } } {
    return (
      metaElementUsage instanceof TextureAreaUsageVO &&
      metaElementUsage.textValue instanceof CompressionSimpleTextValueVO &&
      !metaElementUsage.textValue.autoCompression &&
      !metaElementUsage.textValue.autoFontSize
    );
  }
}
